import loginBg from "./login-bg.jpg";
import userPhoto from "./user.jpg";
import fireDepartementIcon from "./fire-department.png";
import ActionLogo from "./Action_blanc_en_ligne.png";
import ActionLogoGray from "./Action_gris_en_ligne.png";
import red_star from "./red_star.png";
import swimmingPoolsIcon from "./swimming-pools.png";
import waterResourcesIcon from "./water-resources.png";
import buildings_t1 from "./buildings-t1.png";
import buildings_t2 from "./buildings-t2.png";
import buildings_t3 from "./buildings-t3.png";
import buildings_t4 from "./buildings-t4.png";
import configuration from "./configuration.png";
import userGuide from "./userGuide.png";
import climateInnov from "./climate-innov.png";
import edhecLogo from "./edhec-climate-institute.png";
import activeFire from "./activeFire.png";
import historicFire from "./historicFire.png";
import companiesLogos from "./companiesLogos.png";
export const assets = {
  loginBg,
  ActionLogo,
  userPhoto,
  ActionLogoGray,
  fireDepartementIcon,
  red_star,
  swimmingPoolsIcon,
  waterResourcesIcon,
  buildings_t1,
  buildings_t2,
  buildings_t3,
  buildings_t4,
  configuration,
  userGuide,
  climateInnov,
  edhecLogo,
  activeFire,
  historicFire,
  companiesLogos,
};
